<template>
  <div class="source-dialog-custom">
    <md-input-container>
      <label>Название</label>
      <md-input
        :value="value.title"
        :disabled="disabled"
        @input="setValue('title', arguments[0])"
      ></md-input>
    </md-input-container>
    <div class="authors">
      <div
        v-for="author in value.authors"

        class="author-item"
      >
        <md-input-container>
          <label>Фамилия</label>
          <md-input
            :value="author.lastName"
            :disabled="disabled"
            @input="setAuthorValue(author, 'lastName', arguments[0])"
          ></md-input>
        </md-input-container>
        <md-input-container class="first-name">
          <label>Имя (первая буква)</label>
          <md-input
            :value="author.firstNameInitial"
            :disabled="disabled"
            @input="setAuthorValue(author, 'firstNameInitial', arguments[0])"
          ></md-input>
        </md-input-container>
        <md-input-container class="extra-name">
          <label>Отчество (первая буква)</label>
          <md-input
            :value="author.extraNameInitial"
            :disabled="disabled"
            @input="setAuthorValue(author, 'extraNameInitial', arguments[0])"
          ></md-input>
        </md-input-container>
        <md-button @click="removeAuthor(author)">
          <md-icon>close</md-icon>
          <md-tooltip>Удалить автора</md-tooltip>
        </md-button>
      </div>
      <div class="authors-actions">
        <md-button
          class="md-raised"
          :disabled="disabled"
          @click="addAuthor"
        >Добавить автора</md-button>
      </div>
    </div>
    <div
      class="group"
      v-if="value.type === 'article'"
    >
      <md-input-container>
        <label>Год</label>
        <md-input
          :value="value.year"
          :disabled="disabled"
          @input="setValue('year', arguments[0])"
        ></md-input>
      </md-input-container>
      <md-input-container>
        <label>Выпуск</label>
        <md-input
          :value="value.issue"
          :disabled="disabled"
          @input="setValue('issue', arguments[0])"
        ></md-input>
      </md-input-container>
      <md-input-container>
        <label>Страницы</label>
        <md-input
          :value="value.pages"
          :disabled="disabled"
          @input="setValue('pages', arguments[0])"
        ></md-input>
      </md-input-container>
    </div>
    <div
      class="group"
      v-if="value.type === 'resource'"
    >
      <md-input-container>
        <label>Адрес страницы</label>
        <md-input
          type="text"
          :value="value.url"
          :disabled="disabled"
          @input="setValue('url', arguments[0])"
        ></md-input>
      </md-input-container>
    </div>
    <div
      class="group"
    >
      <md-input-container>
        <label>Наименование источника</label>
        <md-input
          type="text"
          :value="value.source"
          :disabled="disabled"
          @input="setValue('source', arguments[0])"
        ></md-input>
      </md-input-container>
    </div>
    <div
      class="group"
      v-if="value.type === 'resource'"
    >
      <md-input-container>
        <label>Режим доступа</label>
        <md-select
          :value="value.accessMode"
          :disabled="disabled"
          @input="setValue('accessMode', arguments[0])"
        >
          <md-option value="free">Свободный</md-option>
          <md-option value="authorize">Требуется авторизация</md-option>
        </md-select>
      </md-input-container>
    </div>
    <div
      class="group"
      v-if="value.type === 'resource'"
    >
      <md-input-container>
        <label>Дата обращеня</label>
        <md-input
          type="date"
          :value="value.accessDate"
          :disabled="disabled"
          @input="setValue('accessDate', arguments[0])"
        ></md-input>
      </md-input-container>
    </div>
  </div>
</template>

<script>
import { getDefaultAuthorData } from '@/shared/defaults.js'

export default {
  name: 'SourceDialogCustom',
  props: {
    value: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setValue (field, value) {
      this.$emit('input', {...this.value, [field]: value})
    },
    setAuthorValue (author, field, value) {
      this.setValue('authors', this.value.authors.map((currentAuthor) => {
        if (author === currentAuthor) {
          return {...currentAuthor, [field]: value}
        } else {
          return currentAuthor
        }
      }))
    },
    addAuthor (author) {
      this.setValue('authors', [...this.value.authors, getDefaultAuthorData()])
    },
    removeAuthor (author) {
      this.setValue('authors', _.without(this.value.authors, author))
    }
  }
}
</script>

<style lang="sass" scoped>
.authors
  .author-item
    display: flex
  .authors-actions
    text-align: right
  .first-name,.extra-name
    max-width: 300px
.group
  display: flex
</style>


// WEBPACK FOOTER //
// SourceDialogCustom.vue?119f1f0c